// Adapter para la API de KPIs de productos
// Products KPIs API adapter

import { apiClientWH } from '@shared/services/ApiClient';

export interface ProductItem {
  name: string;
  code: string;
  image: string;
  qty: number;
  image_url: string;
}

export interface ProductsKpisData {
  product_list: ProductItem[];
  product_sum: number;
  product_count: number;
}

export interface ProductsKpisResponse {
  success: boolean;
  data: ProductsKpisData;
  message: string;
}

export interface ProductsKpisParams {
  date?: string; // Y-m-d format
  shop_id?: number;
}

export class ProductsKpisApiAdapter {
  constructor(private httpClient: typeof apiClientWH) {}

  /**
   * GET /report/products-kpis
   * Parámetros:
   * - date (opcional): Date to filter products (Y-m-d format). Defaults to today
   * - shop_id (opcional): Shop ID to filter products. Optional
   */
  async getProductsKpis(params: ProductsKpisParams = {}): Promise<ProductsKpisResponse> {
    const response = await this.httpClient.get('/report/products-kpis', {
      params: {
        date: params.date,
        shop_id: params.shop_id,
      },
    });

    return response.data;
  }
}
